import { Pin } from 'lucide-react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Markdown } from '@/lib/markdown';
import { formatRelative } from '@/lib/date';
import { PriorityBadge } from './PriorityBadge';
import type { AnnouncementDto } from '../types';

interface AnnouncementCardProps {
  announcement: AnnouncementDto;
}

export function AnnouncementCard({ announcement }: AnnouncementCardProps) {
  return (
    <Card className="overflow-hidden">
      <CardHeader className="flex flex-col gap-2 pb-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex flex-wrap items-center gap-2">
            {announcement.isPinned && (
              <Pin className="h-4 w-4 text-capitol-red-500" aria-label="Pinned" />
            )}
            <h3 className="text-lg font-semibold leading-tight">{announcement.title}</h3>
          </div>
          <p className="text-xs text-muted-foreground">
            {formatRelative(announcement.publishAt ?? announcement.createdAt)}
          </p>
        </div>
        <PriorityBadge priority={announcement.priority} className="shrink-0" />
      </CardHeader>
      <CardContent className="pt-0">
        <Markdown>{announcement.content}</Markdown>
      </CardContent>
    </Card>
  );
}
